import { statsigClient } from '../http/statsig-client'

export async function logEvent(
  eventName: string,
  value?: string | number | null,
  metadata?: Record<string, string> | null
) {
  try {
    await statsigClient.logEvent({ eventName, value, metadata })
  } catch (error) {
    console.error('Error statsig logging event:', error)
  }
}
